import { render, staticRenderFns } from "./FilterCategoryItemCategory.vue?vue&type=template&id=504639ac&"
import script from "./FilterCategoryItemCategory.vue?vue&type=script&lang=js&"
export * from "./FilterCategoryItemCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports